// Aggregated vanilla CSS for shared library primitives — injected ONCE in
// App.tsx (see STYLING.md "shared CSS"). As each library component is migrated
// off Tailwind, append its co-located *Styles export here.
import { buttonStyles } from "../components/buttons/buttonStyles";
import { dividerStyles } from "../components/dividers/dividerStyles";
import { titleStyles } from "../components/titles/titleStyles";
import { loadingStyles } from "../components/loading/loadingStyles";
import { infoStyles } from "../components/infos/infoStyles";
import { barStyles } from "../components/bars/barStyles";
import { cardStyles } from "../components/cards/cardStyles";
import { glassCardStyles } from "../components/glass/glassCardStyles";
import { glassSelectStyles } from "../components/glass/glassSelectStyles";
import { calendarStyles } from "../components/calendar/calendarStyles";
import { labelStyles } from "../components/labels/labelStyles";
import { tabStyles } from "../components/tabs/tabStyles";
import { boxStyles } from "../components/boxes/boxStyles";
import { modalStyles } from "../components/modals/modalStyles";
import { textStyles } from "../components/texts/textStyles";
import { errorStyles } from "../components/errors/errorStyles";
import { dropdownStyles } from "../components/dropdowns/dropdownStyles";
import { pdfStyles } from "../components/pdfs/pdfStyles";
import { pageTravelGroupStyles } from "../components/groups/pageTravelGroupStyles";
import { activitySolveLayoutStyles } from "../components/activities/activitySolveLayoutStyles";
import { activityMiscStyles } from "../components/activities/activityMiscStyles";
import { materialContentStyles } from "../components/activities/material-contents/materialContentStyles";
import { mediaStyles } from "../components/activities/mediaStyles";
import { inputGroupStyles } from "../components/groups/inputGroupStyles";

export const libraryStyles = [
  buttonStyles,
  dividerStyles,
  titleStyles,
  loadingStyles,
  infoStyles,
  barStyles,
  cardStyles,
  glassCardStyles,
  glassSelectStyles,
  calendarStyles,
  labelStyles,
  tabStyles,
  boxStyles,
  modalStyles,
  textStyles,
  errorStyles,
  dropdownStyles,
  pdfStyles,
  pageTravelGroupStyles,
  activitySolveLayoutStyles,
  activityMiscStyles,
  materialContentStyles,
  mediaStyles,
  inputGroupStyles,
].join("\n");
